export { default } from './AvatarGroup.js';
